import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QualificationOutcome } from 'src/app/core/enums/lead/qualification-outcome.enum';
import { Lead } from 'src/app/core/models/lead/lead.model';

@Component({
    selector: 'app-agent-lead-qualified-dialog',
    templateUrl: './agent-lead-qualified-dialog.component.html',
    styleUrls: ['./agent-lead-qualified-dialog.component.scss'],
    standalone: false
})
export class AgentLeadQualifiedDialogComponent {

  public message: string

  constructor(public dialogRef: MatDialogRef<AgentLeadQualifiedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public lead: Lead) {
    this.message = this.getMessage(lead.qualificationOutcome)
  }

  private getMessage(outcome: QualificationOutcome): string {
    switch (outcome) {
      case QualificationOutcome.Interested: return 'agent.qualify.interested';
      case QualificationOutcome.NonInterested: return 'agent.qualify.nonInterested';
      case QualificationOutcome.NeverReplied: return 'agent.qualify.neverReplied';
      case QualificationOutcome.Spam: return 'agent.qualify.spam';
      case QualificationOutcome.Unfitting: return 'agent.qualify.unfitting';
      default: return ''
    }
  }
}
